var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubAreaSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.925 30.2338H10.0172C8.88754 30.2338 7.80415 29.785 7.00536 28.9862C6.20657 28.1874 5.75781 27.1041 5.75781 25.9744V16.3056C5.75787 15.5735 5.94663 14.8538 6.30587 14.2159C6.66511 13.578 7.1827 13.0434 7.80871 12.6638L15.2626 8.14462C15.9285 7.74084 16.6924 7.52734 17.4711 7.52734C18.2499 7.52734 19.0137 7.74084 19.6796 8.14462L27.1335 12.6617C27.7598 13.0415 28.2776 13.5764 28.6369 14.2147C28.9961 14.853 29.1847 15.5731 29.1844 16.3056V25.9744C29.1844 27.1041 28.7357 28.1874 27.9369 28.9862C27.1381 29.785 26.0547 30.2338 24.925 30.2338Z",
    stroke: "white",
    strokeWidth: 2.95479,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6664 30.2277V22.9868C20.6664 22.6479 20.5318 22.3229 20.2922 22.0832C20.0525 21.8436 19.7275 21.709 19.3886 21.709H15.5552C15.2163 21.709 14.8912 21.8436 14.6516 22.0832C14.412 22.3229 14.2773 22.6479 14.2773 22.9868V30.2277",
    stroke: "white",
    strokeWidth: 2.95479,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAreaSelected);
export default __webpack_public_path__ + "static/media/subAreaSelected.9f084ee22b0675f05cabfebe30771412.svg";
export { ForwardRef as ReactComponent };